// // import React, { useState, useEffect } from 'react';
// // import {
// //   Box,
// //   Container,
// //   Paper,
// //   Typography,
// //   Button,
// //   Alert,
// //   CircularProgress,
// //   Grid,
// //   Card,
// //   CardContent,
// //   Avatar,
// //   Chip,
// //   Divider,
// //   IconButton,
// //   Tooltip,
// // } from '@mui/material';
// // import {
// //   LockOutlined,
// //   LogoutOutlined,
// //   RefreshOutlined,
// //   BusinessOutlined,
// //   EmailOutlined,
// //   PersonOutline,
// //   CategoryOutlined,
// //   PhoneOutlined,
// //   LanguageOutlined,
// //   WebhookOutlined,
// //   EventAvailableOutlined,
// //   BadgeOutlined,
// // } from '@mui/icons-material';
// // import { useAuth } from '../context/AuthContext';
// // import { businessAuthService } from '../services/businessAuth';
// // import { useNavigate } from 'react-router-dom';

// // // A single labeled field, used throughout the "Account Information" card.
// // const ProfileField = ({ icon, label, value, mono }) => (
// //   <Grid item xs={12} sm={6}>
// //     <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5 }}>
// //       <Box
// //         sx={{
// //           width: 36,
// //           height: 36,
// //           borderRadius: 1.5,
// //           bgcolor: 'rgba(37, 99, 235, 0.08)',
// //           color: 'primary.main',
// //           display: 'flex',
// //           alignItems: 'center',
// //           justifyContent: 'center',
// //           flexShrink: 0,
// //         }}
// //       >
// //         {icon}
// //       </Box>
// //       <Box sx={{ minWidth: 0 }}>
// //         <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.04em' }}>
// //           {label}
// //         </Typography>
// //         <Typography
// //           variant="body1"
// //           sx={{
// //             fontWeight: 500,
// //             wordBreak: 'break-word',
// //             fontFamily: mono ? 'monospace' : 'inherit',
// //           }}
// //         >
// //           {value || '—'}
// //         </Typography>
// //       </Box>
// //     </Box>
// //   </Grid>
// // );

// // const BusinessProfile = () => {
// //   const { user, logout } = useAuth();
// //   const navigate = useNavigate();

// //   const [loading, setLoading] = useState(true);
// //   const [profile, setProfile] = useState(null);
// //   const [error, setError] = useState('');

// //   useEffect(() => {
// //     fetchBusinessProfile();
// //     // eslint-disable-next-line react-hooks/exhaustive-deps
// //   }, []);

// //   const fetchBusinessProfile = async () => {
// //     setLoading(true);
// //     setError('');
// //     try {
// //       const result = await businessAuthService.getBusinessProfile();
// //       if (result.success) {
// //         // Backend may wrap the payload as { data: {...} } or return it flat.
// //         setProfile(result.data?.data || result.data);
// //       } else {
// //         setError(result.error);
// //       }
// //     } catch (err) {
// //       setError('Failed to fetch profile');
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   const handleChangePassword = () => {
// //     navigate('/business/change-password');
// //   };

// //   const getInitials = () => {
// //     const name = profile?.businessName || user?.businessName || '';
// //     if (!name) return 'B';
// //     return name
// //       .split(' ')
// //       .filter(Boolean)
// //       .slice(0, 2)
// //       .map((w) => w.charAt(0))
// //       .join('')
// //       .toUpperCase();
// //   };

// //   if (loading) {
// //     return (
// //       <Box sx={{ display: 'flex', justifyContent: 'center', py: 10 }}>
// //         <CircularProgress />
// //       </Box>
// //     );
// //   }

// //   const isActive = (profile?.accountStatus || '').toUpperCase() === 'ACTIVE';

// //   return (
// //     <Container maxWidth="md" disableGutters>
// //       <Box sx={{ pb: 4 }}>
// //         {/* Header */}
// //         <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 3, flexWrap: 'wrap', gap: 2 }}>
// //           <Box>
// //             <Typography variant="h5" sx={{ fontWeight: 700, color: 'text.primary' }}>
// //               Business Profile
// //             </Typography>
// //             <Typography variant="body2" sx={{ color: 'text.secondary', mt: 0.5 }}>
// //               View your account and business details.
// //             </Typography>
// //           </Box>
// //           <Tooltip title="Refresh">
// //             <IconButton onClick={fetchBusinessProfile} sx={{ border: '1px solid', borderColor: 'divider' }}>
// //               <RefreshOutlined fontSize="small" />
// //             </IconButton>
// //           </Tooltip>
// //         </Box>

// //         {error && (
// //           <Alert severity="error" sx={{ mb: 3, borderRadius: 1.5 }}>
// //             {error}
// //           </Alert>
// //         )}

// //         {profile && (
// //           <>
// //             {/* Identity summary card */}
// //             <Paper
// //               variant="outlined"
// //               sx={{
// //                 p: 3,
// //                 mb: 3,
// //                 borderRadius: 2,
// //                 display: 'flex',
// //                 alignItems: 'center',
// //                 gap: 2.5,
// //                 flexWrap: 'wrap',
// //               }}
// //             >
// //               <Avatar
// //                 sx={{
// //                   width: 64,
// //                   height: 64,
// //                   bgcolor: 'primary.main',
// //                   color: 'primary.contrastText',
// //                   fontWeight: 700,
// //                   fontSize: '1.4rem',
// //                 }}
// //               >
// //                 {getInitials()}
// //               </Avatar>
// //               <Box sx={{ flexGrow: 1, minWidth: 200 }}>
// //                 <Typography variant="h6" sx={{ fontWeight: 700 }}>
// //                   {profile.businessName || '—'}
// //                 </Typography>
// //                 <Typography variant="body2" sx={{ color: 'text.secondary' }}>
// //                   {profile.contactEmail || profile.email || '—'}
// //                 </Typography>
// //               </Box>
// //               <Chip
// //                 label={isActive ? 'Active' : profile.accountStatus || 'Inactive'}
// //                 sx={{
// //                   bgcolor: isActive ? 'rgba(22, 163, 74, 0.1)' : 'rgba(220, 38, 38, 0.1)',
// //                   color: isActive ? 'success.main' : 'error.main',
// //                   fontWeight: 600,
// //                   borderRadius: 1.5,
// //                 }}
// //               />
// //             </Paper>

// //             {/* Account information */}
// //             <Card variant="outlined" sx={{ borderRadius: 2, boxShadow: 'none', mb: 3 }}>
// //               <CardContent sx={{ p: 3 }}>
// //                 <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 2 }}>
// //                   Account Information
// //                 </Typography>

// //                 <Grid container spacing={2.5}>
// //                   <ProfileField icon={<BusinessOutlined fontSize="small" />} label="Business Name" value={profile.businessName} />
// //                   <ProfileField icon={<BadgeOutlined fontSize="small" />} label="Business ID" value={profile.businessId} mono />
// //                   <ProfileField icon={<PersonOutline fontSize="small" />} label="Username" value={profile.username} />
// //                   <ProfileField icon={<EmailOutlined fontSize="small" />} label="Contact Email" value={profile.contactEmail || profile.email} />
// //                   <ProfileField icon={<CategoryOutlined fontSize="small" />} label="Industry" value={profile.industry} />
// //                   <ProfileField icon={<PhoneOutlined fontSize="small" />} label="Emergency Contact" value={profile.emergencyContactNo} />
// //                   <ProfileField icon={<LanguageOutlined fontSize="small" />} label="Website URL" value={profile.websiteUrl} />
// //                   <ProfileField icon={<WebhookOutlined fontSize="small" />} label="Webhook URL" value={profile.webhookUrl} />
// //                   <ProfileField
// //                     icon={<EventAvailableOutlined fontSize="small" />}
// //                     label="Member Since"
// //                     value={profile.createdAt ? new Date(profile.createdAt).toLocaleDateString() : null}
// //                   />
// //                 </Grid>
// //               </CardContent>
// //             </Card>

// //             <Divider sx={{ mb: 3 }} />

// //             <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
// //               <Button
// //                 variant="contained"
// //                 color="primary"
// //                 startIcon={<LockOutlined />}
// //                 onClick={handleChangePassword}
// //                 sx={{ borderRadius: 1.5 }}
// //               >
// //                 Change Password
// //               </Button>

// //               <Button
// //                 variant="outlined"
// //                 color="error"
// //                 startIcon={<LogoutOutlined />}
// //                 onClick={logout}
// //                 sx={{ borderRadius: 1.5 }}
// //               >
// //                 Logout
// //               </Button>
// //             </Box>
// //           </>
// //         )}
// //       </Box>
// //     </Container>
// //   );
// // };

// // export default BusinessProfile;


// import React, { useState, useEffect } from 'react';
// import {
//   Box,
//   Container,
//   Paper,
//   Typography,
//   Button,
//   Alert,
//   CircularProgress,
//   Grid,
//   Card,
//   CardContent,
//   Avatar,
//   Chip,
//   Divider,
//   IconButton,
//   Tooltip,
//   Stack,
// } from '@mui/material';
// import {
//   LockOutlined,
//   LogoutOutlined,
//   RefreshOutlined,
//   BusinessOutlined,
//   EmailOutlined,
//   PersonOutline,
//   CategoryOutlined,
//   PhoneOutlined,
//   LanguageOutlined,
//   WebhookOutlined,
//   EventAvailableOutlined,
//   BadgeOutlined,
// } from '@mui/icons-material';
// import { useAuth } from '../context/AuthContext';
// import { businessAuthService } from '../services/businessAuth';
// import { useNavigate } from 'react-router-dom';

// /* ------------------------------------------------------------------ */
// /* Small building blocks                                              */
// /* ------------------------------------------------------------------ */

// // A single labeled field row — icon tile + label + value.
// const ProfileField = ({ icon, label, value, mono }) => {
//   const hasValue = value !== undefined && value !== null && value !== '';

//   return (
//     <Box
//       sx={{
//         display: 'flex',
//         alignItems: 'center',
//         gap: 1.5,
//         px: 0,
//         py: 1.1,
//         borderRadius: 1,
//       }}
//     >
//       <Box
//         sx={{
//           width: 36,
//           height: 36,
//           borderRadius: 1.5,
//           bgcolor: '#EAF2FF',
//           color: '#2563EB',
//           display: 'flex',
//           alignItems: 'center',
//           justifyContent: 'center',
//           flexShrink: 0,
//           border: '1px solid #D9E7FF',
//         }}
//       >
//         {icon}
//       </Box>

//       <Box sx={{ minWidth: 0, flex: 1 }}>
//         <Typography
//           variant="caption"
//           sx={{
//             display: 'block',
//             color: '#6B7280',
//             fontWeight: 700,
//             textTransform: 'uppercase',
//             letterSpacing: '0.08em',
//             fontSize: '0.68rem',
//             mb: 0.4,
//           }}
//         >
//           {label}
//         </Typography>
//         <Typography
//           variant="body1"
//           sx={{
//             fontWeight: 600,
//             wordBreak: 'break-word',
//             color: hasValue ? '#111827' : '#9CA3AF',
//             fontFamily: mono ? 'ui-monospace, SFMono-Regular, Menlo, monospace' : 'inherit',
//             lineHeight: 1.5,
//           }}
//         >
//           {hasValue ? value : 'Not provided'}
//         </Typography>
//       </Box>
//     </Box>
//   );
// };

// // A titled card wrapper that keeps every section visually consistent.
// const SectionCard = ({ title, subtitle, children, sx }) => (
//   <Card
//     elevation={0}
//     sx={{
//       height: '100%',
//       borderRadius: 2,
//       border: '1px solid #E5E7EB',
//       backgroundColor: '#FFFFFF',
//       boxShadow: 'none',
//       ...sx,
//     }}
//   >
//     <CardContent
//       sx={{
//         p: { xs: 2, sm: 2.25 },
//         '&:last-child': { pb: { xs: 2, sm: 2.25 } },
//       }}
//     >
//       <Typography variant="h6" sx={{ fontWeight: 700, fontSize: '1.1rem', color: '#111827', letterSpacing: '-0.01em' }}>
//         {title}
//       </Typography>
//       {subtitle && (
//         <Typography variant="body2" sx={{ color: '#6B7280', mt: 0.5, fontSize: '0.96rem' }}>
//           {subtitle}
//         </Typography>
//       )}

//       <Divider sx={{ my: 2, borderColor: '#E5E7EB' }} />

//       {children}
//     </CardContent>
//   </Card>
// );

// /* ------------------------------------------------------------------ */
// /* Page                                                               */
// /* ------------------------------------------------------------------ */

// const BusinessProfile = () => {
//   const { user, logout } = useAuth();
//   const navigate = useNavigate();

//   const [loading, setLoading] = useState(true);
//   const [profile, setProfile] = useState(null);
//   const [error, setError] = useState('');

//   useEffect(() => {
//     fetchBusinessProfile();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   const fetchBusinessProfile = async () => {
//     setLoading(true);
//     setError('');
//     try {
//       const result = await businessAuthService.getBusinessProfile();
//       if (result.success) {
//         const businessData = result.data?.data || result.data || {};
//         setProfile(businessData);
//       } else {
//         setError(result.error || 'Failed to fetch profile');
//       }
//     } catch (err) {
//       setError('Failed to fetch profile');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleChangePassword = () => {
//     navigate('/business/change-password');
//   };

//   const getInitials = () => {
//     const name = profile?.businessName || user?.businessName || '';
//     if (!name) return 'B';
//     return name
//       .split(' ')
//       .filter(Boolean)
//       .slice(0, 2)
//       .map((w) => w.charAt(0))
//       .join('')
//       .toUpperCase();
//   };

//   if (loading) {
//     return (
//       <Box
//         sx={{
//           display: 'flex',
//           flexDirection: 'column',
//           alignItems: 'center',
//           justifyContent: 'center',
//           minHeight: '60vh',
//           gap: 2,
//         }}
//       >
//         <CircularProgress size={36} thickness={4} />
//         <Typography variant="body2" sx={{ color: 'text.secondary' }}>
//           Loading your profile…
//         </Typography>
//       </Box>
//     );
//   }

//   const businessName = profile?.businessName || user?.businessName || 'Business Profile';
//   const contactEmail = profile?.contactEmail || profile?.email || user?.email || 'Not provided';
//   const businessId = profile?.businessId || profile?.id || user?.businessId || user?.tenantId || 'Not provided';
//   const accountStatus = (profile?.accountStatus || user?.accountStatus || 'INACTIVE').toUpperCase();
//   const isActive = accountStatus === 'ACTIVE';
//   const statusLabel = isActive ? 'Active' : accountStatus || 'Inactive';
//   const memberSince = profile?.createdAt
//     ? new Date(profile.createdAt).toLocaleDateString(undefined, {
//         year: 'numeric',
//         month: 'long',
//         day: 'numeric',
//       })
//     : 'Not provided';

//   return (
//     <Container maxWidth="xl" sx={{ py: { xs: 2.5, md: 3.5 }, px: { xs: 2, md: 3 }, minHeight: '100vh' }}>
//       <Box
//         sx={{
//           display: 'flex',
//           justifyContent: 'space-between',
//           alignItems: 'center',
//           flexWrap: 'wrap',
//           gap: 2,
//           mb: 2.5,
//         }}
//       >
//         <Box>
//           <Typography variant="h4" sx={{ fontWeight: 700, letterSpacing: '-0.03em', color: '#111827', lineHeight: 1.2 }}>
//             Business Profile
//           </Typography>
//           <Typography variant="body1" sx={{ color: '#6B7280', mt: 0.5, fontSize: '1.02rem' }}>
//             Manage your business information and account details.
//           </Typography>
//         </Box>

//         <Tooltip title="Refresh profile">
//           <IconButton
//             onClick={fetchBusinessProfile}
//             sx={{
//               width: 38,
//               height: 38,
//               border: '1px solid #D1D5DB',
//               borderRadius: '50%',
//               backgroundColor: '#F3F4F6',
//               color: '#374151',
//               '&:hover': { backgroundColor: '#E5E7EB' },
//             }}
//           >
//             <RefreshOutlined fontSize="small" />
//           </IconButton>
//         </Tooltip>
//       </Box>

//       {error && (
//         <Alert severity="error" sx={{ mb: 3, borderRadius: 2 }}>
//           {error}
//         </Alert>
//       )}

//       {!profile && !error && (
//         <Paper variant="outlined" sx={{ p: 4, borderRadius: 2, textAlign: 'center' }}>
//           <Typography variant="body1" sx={{ color: 'text.secondary' }}>
//             No profile information available.
//           </Typography>
//         </Paper>
//       )}

//       {profile && (
//         <Stack spacing={{ xs: 2, md: 2.5 }}>
//           <Paper
//             elevation={0}
//             sx={{
//               position: 'relative',
//               overflow: 'hidden',
//               borderRadius: 2,
//               p: { xs: 2, sm: 2.25 },
//               border: '1px solid #E5E7EB',
//               backgroundColor: '#FFFFFF',
//               boxShadow: 'none',
//               borderTop: '3px solid #2563EB',
//             }}
//           >
//             <Box
//               sx={{
//                 position: 'relative',
//                 display: 'flex',
//                 alignItems: 'center',
//                 gap: { xs: 2, sm: 2.25 },
//                 flexWrap: 'wrap',
//                 py: 0.25,
//               }}
//             >
//               <Avatar
//                 sx={{
//                   width: { xs: 52, sm: 56 },
//                   height: { xs: 52, sm: 56 },
//                   bgcolor: '#EAF2FF',
//                   color: '#2563EB',
//                   border: '1px solid #D7E7FF',
//                   fontWeight: 700,
//                   fontSize: { xs: '1.2rem', sm: '1.55rem' },
//                 }}
//               >
//                 {getInitials()}
//               </Avatar>

//               <Box sx={{ flexGrow: 1, minWidth: 220 }}>
//                 <Typography variant="h5" sx={{ fontWeight: 700, letterSpacing: '-0.02em', color: '#111827', lineHeight: 1.2 }}>
//                   {businessName}
//                 </Typography>
//                 <Typography variant="body2" sx={{ color: '#6B7280', mt: 0.5, fontSize: '0.98rem' }}>
//                   {contactEmail}
//                 </Typography>
//               </Box>

//               <Chip
//                 label={
//                   <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
//                     <Box
//                       sx={{
//                         width: 8,
//                         height: 8,
//                         borderRadius: '50%',
//                         bgcolor: isActive ? '#22C55E' : '#DC2626',
//                       }}
//                     />
//                     {statusLabel}
//                   </Box>
//                 }
//                 sx={{
//                   bgcolor: isActive ? '#E8F7EE' : '#FDECEC',
//                   color: isActive ? '#15803D' : '#B91C1C',
//                   border: '1px solid',
//                   borderColor: isActive ? '#CFEBD8' : '#F4C2C2',
//                   borderRadius: 999,
//                   fontWeight: 600,
//                   px: 1,
//                   py: 0.15,
//                   height: 30,
//                   '& .MuiChip-label': { display: 'flex', alignItems: 'center', px: 0.6 },
//                 }}
//               />
//             </Box>
//           </Paper>

//           <Grid container spacing={{ xs: 2, md: 2.5 }}>
//             <Grid item xs={12} md={6}>
//               <SectionCard title="Business Details" subtitle="Primary information about your organisation.">
//                 <Grid container spacing={1.5}>
//                   <Grid item xs={12}><ProfileField icon={<BusinessOutlined fontSize="small" />} label="Business Name" value={profile.businessName || businessName} /></Grid>
//                   <Grid item xs={12}><ProfileField icon={<BadgeOutlined fontSize="small" />} label="Business ID" value={businessId} mono /></Grid>
//                   <Grid item xs={12}><ProfileField icon={<PersonOutline fontSize="small" />} label="Username" value={profile.username || user?.username || 'Not provided'} /></Grid>
//                   <Grid item xs={12}><ProfileField icon={<CategoryOutlined fontSize="small" />} label="Industry" value={profile.industry || 'Not provided'} /></Grid>
//                 </Grid>
//               </SectionCard>
//             </Grid>

//             <Grid item xs={12} md={6}>
//               <SectionCard title="Contact & Integration" subtitle="How to contact your team and where outbound events are sent.">
//                 <Grid container spacing={1.5}>
//                   <Grid item xs={12}><ProfileField icon={<EmailOutlined fontSize="small" />} label="Contact Email" value={contactEmail} /></Grid>
//                   <Grid item xs={12}><ProfileField icon={<PhoneOutlined fontSize="small" />} label="Emergency Contact" value={profile.emergencyContactNo || 'Not provided'} /></Grid>
//                   <Grid item xs={12}><ProfileField icon={<LanguageOutlined fontSize="small" />} label="Website URL" value={profile.websiteUrl || 'Not provided'} /></Grid>
//                   <Grid item xs={12}><ProfileField icon={<WebhookOutlined fontSize="small" />} label="Webhook URL" value={profile.webhookUrl || 'Not provided'} mono /></Grid>
//                 </Grid>
//               </SectionCard>
//             </Grid>

//             <Grid item xs={12}>
//               <SectionCard title="Account & Security" subtitle="Current status and account access settings.">
//                 <Grid container spacing={2} sx={{ mb: 0.5 }}>
//                   <Grid item xs={12} sm={6}>
//                     <ProfileField icon={<EventAvailableOutlined fontSize="small" />} label="Member Since" value={memberSince} />
//                   </Grid>
//                   <Grid item xs={12} sm={6}>
//                     <ProfileField icon={<BadgeOutlined fontSize="small" />} label="Authentication Type" value={profile.authType || user?.authType || 'IN_APP'} />
//                   </Grid>
//                 </Grid>

//                 <Divider sx={{ my: 2.5 }} />

//                 <Box sx={{ display: 'flex', gap: 1.5, flexWrap: 'wrap', alignItems: 'center' }}>
//                   <Button
//                     variant="contained"
//                     color="primary"
//                     size="large"
//                     startIcon={<LockOutlined />}
//                     onClick={handleChangePassword}
//                     disableElevation
//                     sx={{ borderRadius: 2, px: 2.5, py: 1, fontWeight: 600 }}
//                   >
//                     Change Password
//                   </Button>

//                   <Button
//                     variant="outlined"
//                     color="error"
//                     size="large"
//                     startIcon={<LogoutOutlined />}
//                     onClick={logout}
//                     sx={{ borderRadius: 2, px: 2.5, py: 1, fontWeight: 600 }}
//                   >
//                     Logout
//                   </Button>
//                 </Box>
//               </SectionCard>
//             </Grid>
//           </Grid>
//         </Stack>
//       )}
//     </Container>
//   );
// };

// export default BusinessProfile;

import React, { useState, useEffect } from 'react';
import {
  Box,
  Container,
  Paper,
  Typography,
  Button,
  Alert,
  CircularProgress,
  Grid,
  Card,
  CardContent,
  Avatar,
  Chip,
  Divider,
  IconButton,
  Tooltip,
  Stack,
} from '@mui/material';
import {
  LockOutlined,
  LogoutOutlined,
  RefreshOutlined,
  BusinessOutlined,
  EmailOutlined,
  PersonOutline,
  CategoryOutlined,
  PhoneOutlined,
  LanguageOutlined,
  WebhookOutlined,
  EventAvailableOutlined,
  BadgeOutlined,
  EditOutlined,
} from '@mui/icons-material';
import { useAuth } from '../context/AuthContext';
import { businessAuthService } from '../services/businessAuth';
import { useNavigate } from 'react-router-dom';

/* ------------------------------------------------------------------ */
/* Small building blocks                                              */
/* ------------------------------------------------------------------ */

// A single labeled field row — icon tile + label + value.
const ProfileField = ({ icon, label, value, mono }) => {
  const hasValue = value !== undefined && value !== null && value !== '';

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        px: 0,
        py: 1.25,
        borderRadius: 1,
      }}
    >
      <Box
        sx={{
          width: 40,
          height: 40,
          borderRadius: 2,
          color: 'text.secondary',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
          border: '1px solid',
          borderColor: 'divider',
          backgroundColor: 'action.hover',
        }}
      >
        {icon}
      </Box>

      <Box sx={{ minWidth: 0, flex: 1 }}>
        <Typography
          variant="caption"
          sx={{
            display: 'block',
            color: 'text.secondary',
            fontWeight: 600,
            textTransform: 'uppercase',
            letterSpacing: '0.05em',
            fontSize: '0.7rem',
            mb: 0.25,
          }}
        >
          {label}
        </Typography>
        <Typography
          variant="body1"
          sx={{
            fontWeight: 500,
            wordBreak: 'break-word',
            color: hasValue ? 'text.primary' : 'text.disabled',
            fontStyle: hasValue ? 'normal' : 'italic',
            fontFamily: mono ? 'ui-monospace, SFMono-Regular, Menlo, monospace' : 'inherit',
            lineHeight: 1.5,
          }}
        >
          {hasValue ? value : 'Not provided'}
        </Typography>
      </Box>
    </Box>
  );
};

// A titled card wrapper that keeps every section visually consistent.
const SectionCard = ({ title, subtitle, children, sx, onEdit }) => (
  <Card
    elevation={0}
    sx={{
      height: '100%',
      borderRadius: 3,
      border: '1px solid',
      borderColor: 'divider',
      backgroundColor: 'background.paper',
      boxShadow: '0 2px 12px rgba(0, 0, 0, 0.03)',
      ...sx,
    }}
  >
    <CardContent
      sx={{
        p: { xs: 2.5, sm: 3.5 },
        '&:last-child': { pb: { xs: 2.5, sm: 3.5 } },
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>
        <Box>
          <Typography variant="h6" sx={{ fontWeight: 600, fontSize: '1.15rem', color: 'text.primary', letterSpacing: '-0.01em' }}>
            {title}
          </Typography>
          {subtitle && (
            <Typography variant="body2" sx={{ color: 'text.secondary', mt: 0.5, fontSize: '0.95rem' }}>
              {subtitle}
            </Typography>
          )}
        </Box>
        {onEdit && (
          <IconButton size="small" onClick={onEdit} sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2, color: 'text.secondary' }}>
            <EditOutlined fontSize="small" />
          </IconButton>
        )}
      </Box>

      <Divider sx={{ mb: 2.5, borderColor: 'divider' }} />

      {children}
    </CardContent>
  </Card>
);

/* ------------------------------------------------------------------ */
/* Page                                                               */
/* ------------------------------------------------------------------ */

const BusinessProfile = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [profile, setProfile] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchBusinessProfile();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchBusinessProfile = async () => {
    setLoading(true);
    setError('');
    try {
      const result = await businessAuthService.getBusinessProfile();
      if (result.success) {
        const businessData = result.data?.data || result.data || {};
        setProfile(businessData);
      } else {
        setError(result.error || 'Failed to fetch profile');
      }
    } catch (err) {
      setError('Failed to fetch profile');
    } finally {
      setLoading(false);
    }
  };

  const handleChangePassword = () => {
    navigate('/business/change-password');
  };

  const getInitials = () => {
    const name = profile?.businessName || user?.businessName || '';
    if (!name) return 'B';
    return name
      .split(' ')
      .filter(Boolean)
      .slice(0, 2)
      .map((w) => w.charAt(0))
      .join('')
      .toUpperCase();
  };

  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '60vh',
          gap: 2,
        }}
      >
        <CircularProgress size={36} thickness={4} />
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          Loading your profile…
        </Typography>
      </Box>
    );
  }

  const businessName = profile?.businessName || user?.businessName || 'Business Profile';
  const contactEmail = profile?.contactEmail || profile?.email || user?.email || '';
  const businessId = profile?.businessId || profile?.id || user?.businessId || user?.tenantId || '';
  const accountStatus = (profile?.accountStatus || user?.accountStatus || 'INACTIVE').toUpperCase();
  const isActive = accountStatus === 'ACTIVE';
  const statusLabel = isActive ? 'Active' : accountStatus || 'Inactive';
  const memberSince = profile?.createdAt
    ? new Date(profile.createdAt).toLocaleDateString(undefined, {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      })
    : '';

  return (
    <Container maxWidth="xl" sx={{ py: { xs: 3, md: 4 }, px: { xs: 2, md: 3 }, minHeight: '100vh', bgcolor: 'background.default' }}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: 2,
          mb: 3.5,
        }}
      >
        <Box>
          <Typography variant="h4" sx={{ fontWeight: 700, letterSpacing: '-0.03em', color: 'text.primary', lineHeight: 1.2 }}>
            Business Profile
          </Typography>
          <Typography variant="body1" sx={{ color: 'text.secondary', mt: 0.5, fontSize: '1.02rem' }}>
            Manage your business information and account details.
          </Typography>
        </Box>

        <Tooltip title="Refresh profile">
          <IconButton
            onClick={fetchBusinessProfile}
            sx={{
              width: 40,
              height: 40,
              border: '1px solid',
              borderColor: 'divider',
              borderRadius: '50%',
              backgroundColor: 'background.paper',
              color: 'text.primary',
              boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)',
              '&:hover': { backgroundColor: 'action.hover' },
            }}
          >
            <RefreshOutlined fontSize="small" />
          </IconButton>
        </Tooltip>
      </Box>

      {error && (
        <Alert severity="error" sx={{ mb: 3, borderRadius: 2 }}>
          {error}
        </Alert>
      )}

      {!profile && !error && (
        <Paper variant="outlined" sx={{ p: 4, borderRadius: 2, textAlign: 'center' }}>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            No profile information available.
          </Typography>
        </Paper>
      )}

      {profile && (
        <Stack spacing={{ xs: 2.5, md: 3 }}>
          <Paper
            elevation={0}
            sx={{
              position: 'relative',
              overflow: 'hidden',
              borderRadius: 3,
              p: { xs: 2.5, sm: 3.5 },
              border: '1px solid',
              borderColor: 'divider',
              backgroundColor: 'background.paper',
              boxShadow: '0 4px 15px rgba(0, 0, 0, 0.03)',
            }}
          >
            <Box
              sx={{
                position: 'relative',
                display: 'flex',
                alignItems: 'center',
                gap: { xs: 2.5, sm: 3 },
                flexWrap: 'wrap',
              }}
            >
              <Avatar
                sx={{
                  width: { xs: 60, sm: 68 },
                  height: { xs: 60, sm: 68 },
                  bgcolor: 'primary.main',
                  color: 'primary.contrastText',
                  border: '1px solid',
                  borderColor: 'divider',
                  fontWeight: 700,
                  fontSize: { xs: '1.3rem', sm: '1.65rem' },
                }}
              >
                {getInitials()}
              </Avatar>

              <Box sx={{ flexGrow: 1, minWidth: 220 }}>
                <Typography variant="h5" sx={{ fontWeight: 700, letterSpacing: '-0.02em', color: 'text.primary', lineHeight: 1.2 }}>
                  {businessName}
                </Typography>
                <Typography variant="body2" sx={{ color: 'text.secondary', mt: 0.5, fontSize: '1rem' }}>
                  {contactEmail || 'No email provided'}
                </Typography>
              </Box>

              <Chip
                label={
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
                    <Box
                      sx={{
                        width: 8,
                        height: 8,
                        borderRadius: '50%',
                        bgcolor: isActive ? '#22C55E' : '#DC2626',
                      }}
                    />
                    {statusLabel}
                  </Box>
                }
                sx={{
                  bgcolor: isActive ? '#E8F7EE' : '#FDECEC',
                  color: isActive ? '#15803D' : '#B91C1C',
                  border: '1px solid',
                  borderColor: isActive ? '#CFEBD8' : '#F4C2C2',
                  borderRadius: 999,
                  fontWeight: 600,
                  px: 1,
                  py: 0.15,
                  height: 32,
                  '& .MuiChip-label': { display: 'flex', alignItems: 'center', px: 0.6 },
                }}
              />
            </Box>
          </Paper>

          <Grid container spacing={{ xs: 2.5, md: 3 }}>
            <Grid item xs={12} md={6}>
              <SectionCard
                title="Business Details"
                subtitle="Primary information about your organisation."
              >
                <Grid container spacing={1.5}>
                  <Grid item xs={12}><ProfileField icon={<BusinessOutlined fontSize="small" />} label="Business Name" value={profile.businessName || businessName} /></Grid>
                  <Grid item xs={12}><ProfileField icon={<BadgeOutlined fontSize="small" />} label="Business ID" value={businessId} mono /></Grid>
                  <Grid item xs={12}><ProfileField icon={<PersonOutline fontSize="small" />} label="Username" value={profile.username || user?.username} /></Grid>
                  <Grid item xs={12}><ProfileField icon={<CategoryOutlined fontSize="small" />} label="Industry" value={profile.industry} /></Grid>
                </Grid>
              </SectionCard>
            </Grid>

            <Grid item xs={12} md={6}>
              <SectionCard
                title="Contact & Integration"
                subtitle="How to contact your team and where outbound events are sent."
              >
                <Grid container spacing={1.5}>
                  <Grid item xs={12}><ProfileField icon={<EmailOutlined fontSize="small" />} label="Contact Email" value={contactEmail} /></Grid>
                  <Grid item xs={12}><ProfileField icon={<PhoneOutlined fontSize="small" />} label="Emergency Contact" value={profile.emergencyContactNo} /></Grid>
                  <Grid item xs={12}><ProfileField icon={<LanguageOutlined fontSize="small" />} label="Website URL" value={profile.websiteUrl} /></Grid>
                  <Grid item xs={12}><ProfileField icon={<WebhookOutlined fontSize="small" />} label="Webhook URL" value={profile.webhookUrl} mono /></Grid>
                </Grid>
              </SectionCard>
            </Grid>

            <Grid item xs={12}>
              <SectionCard title="Account & Security" subtitle="Current status and account access settings.">
                <Grid container spacing={3} sx={{ mb: 1 }}>
                  <Grid item xs={12} sm={6}>
                    <ProfileField icon={<EventAvailableOutlined fontSize="small" />} label="Member Since" value={memberSince} />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <ProfileField icon={<BadgeOutlined fontSize="small" />} label="Authentication Type" value={profile.authType || user?.authType || 'IN_APP'} />
                  </Grid>
                </Grid>

                <Divider sx={{ my: 3, borderColor: '#F3F4F6' }} />

                <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', alignItems: 'center' }}>
                  <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    startIcon={<LockOutlined />}
                    onClick={handleChangePassword}
                    disableElevation
                    sx={{ borderRadius: 2, px: 3, py: 1.25, fontWeight: 600 }}
                  >
                    Change Password
                  </Button>

                  <Button
                    variant="outlined"
                    color="error"
                    size="large"
                    startIcon={<LogoutOutlined />}
                    onClick={logout}
                    sx={{ borderRadius: 2, px: 3, py: 1.25, fontWeight: 600, borderColor: '#FCA5A5' }}
                  >
                    Logout
                  </Button>
                </Box>
              </SectionCard>
            </Grid>
          </Grid>
        </Stack>
      )}
    </Container>
  );
};

export default BusinessProfile;